var _defs, _path, _line, _line2, _line3, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#414042;stroke-linecap:round;stroke-linejoin:round;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0.5,29.38h0a2.12,2.12,0,0,1,.62-1.5l6.76-6.76a2.12,2.12,0,0,1,1.5-.62h0a2.12,2.12,0,0,1,2.12,2.12h0a2.12,2.12,0,0,1-.62,1.5L4.12,30.88a2.12,2.12,0,0,1-1.5.62h0A2.12,2.12,0,0,1,.5,29.38Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.72,
    x2: 10.88,
    y1: 19.28,
    y2: 21.12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.5,
    x2: 7.5,
    y1: 24.5,
    y2: 21.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.5,
    x2: 1.5,
    y1: 30.5,
    y2: 27.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.5,
    cy: 11.5,
    r: 11
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 20.5,
    cy: 11.5,
    r: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.5,4.5a7,7,0,0,0-7,7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav);
export default __webpack_public_path__ + "static/media/nav.565730a440a640dbaee18166c2374f01.svg";
export { ForwardRef as ReactComponent };